<template>
  <div>
    <h5>{{ title }}</h5>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-row class="mx-0 mt-1">
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$tc('hanwha_camera.group')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$tc('hanwha_camera.group')"
              label-for="group_id"
              :state="getValidationState(validationContext)"
            >
              <v-select
                label="UserGroupID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="groupsInfo"
                class="w-100"
                :reduce="(val) => val.UserGroupID"
                v-model="itemData.group_id"
                append-to-body
                :calculate-position="withPopper"
              />

              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col v-if="!itemData.isEdit" cols="6">
          <validation-provider
            #default="validationContext"
            :name="$tc('hanwha_camera.user_id')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$tc('hanwha_camera.user_id')"
              label-for="user_id"
            >
              <b-form-input
                id="user_id"
                v-model="itemData.user_id"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$tc('hanwha_camera.username')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$tc('hanwha_camera.username')"
              label-for="user_name"
            >
              <b-form-input
                id="user_name"
                v-model="itemData.user_name"
                 maxlength="16"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$tc('hanwha_camera.user_level')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$tc('hanwha_camera.user_level')"
              label-for="user_level"
              :state="getValidationState(validationContext)"
            >
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="userLevelOptions"
                class="w-100"
                :reduce="(val) => val.value"
                v-model="itemData.user_level"
                append-to-body
                :calculate-position="withPopper"
              />

              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col> -->
        <b-col v-if="!itemData.isEdit" cols="6">
          <validation-provider
            #default="validationContext"
            :name="$tc('hanwha_camera.password')"
            rules="required"
          >
            <label
              id="password"
              for="user_name"
              class="w-100 d-flex justify-content-between"
            >
              {{ $tc('hanwha_camera.password') }}
              <feather-icon
                icon="InfoIcon"
                size="16"
                v-b-popover.hover.html="popoverConfig"
                title="Información de contraseña"
              />
            </label>
            <b-form-input
              id="password"
              type="password"
              v-model="itemData.password"
              :state="getValidationState(validationContext)"
              trim
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>
        <b-col
          v-if="!itemData.isEdit"
          class="d-flex align-items-end"
          cols="6"
        >
          <validation-provider
            #default="validationContext"
            name="ViewerAccess"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              label=""
              label-for="viewer_access"
            >
              <b-form-checkbox
                v-model="itemData.viewer_access"
                class="text-capitalize"
                switch
              >
                {{ $t('hanwha_camera.viewer_access') }}
              </b-form-checkbox>

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col v-if="itemData.isEdit" cols="6">
          <validation-provider
            #default="validationContext"
            name="Password"
            rules="required"
          >
            <label
              id="password"
              for="password"
            >
              {{ $t('hanwha_camera.password_confirm') }}
            </label>
            <b-form-input
              id="password"
              type="password"
              v-model="itemData.password"
              :state="getValidationState(validationContext)"
              trim
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>

<script>
import { computed,ref } from "@vue/composition-api";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";
import formValidation from "@core/comp-functions/forms/form-validation";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  components: {
    flatPickr,
    ValidationObserver,
    ValidationProvider,
    vSelect
  },
  props: {
    groupsInfo: {
      type: Array
    },
    itemData: {
      type: Object
    }
  },
  setup (props) {
    //COMPOSABLES
    const { refFormObserver, getValidationState } = formValidation();

    const { t,tc } = useI18nUtils();

    //DATA
    const userLevelOptions = ref([
      {
        label: 'Admin',
        value: 'Admin'
      },
      {
        label: 'Guest',
        value: 'Guest'
      },
      {
        label: 'User',
        value: 'User'
      }
    ]);

    //COMPUTED
    const title = computed(() => (props.itemData.isEdit) ? `${t('actions.update')} ${tc('hanwha_dvr.user', 1)} ${props.itemData.user_id}` : `${t('actions.add')}  ${tc('hanwha_dvr.user', 1)}`);

    //METHODS
    const popoverConfig = () => {
      return `
        <div>
          <small>- Debe tener entre 8 y 20 caracteres, contener letras y números.</small>
        </div>
        <div>
          <small>- No debe contener espacios, caracteres especiales ni emojis.</small>
        </div>
        <div>
          <small>- El ID de usuario no podrá utilizarse como contraseña</small>
        </div>
        <div>
          <small>- No utilice más de 4 caracteres consecutivos (ej. 1234, abcd, etc.).</small>
        </div>
        <div>
          <small>No utilice el mismo carácter repetidamente más de 4 veces (ej. !!!!, 1111, aaaa, etc.).</small>
        </div>
      `;
    }

    const validateStep = async () => {
      if (!refFormObserver.value) {
        console.warn("Validation observer is not initialized");
        return false;
      }

      const validation = await refFormObserver.value.validate();

      return validation;
    }

    return {
      getValidationState,
      refFormObserver,

      title,
      userLevelOptions,

      popoverConfig,
      validateStep,
      withPopper: popperHelper.withPopper
    }
  }
}
</script>
